module.exports = __webpack_public_path__ + "cement/img/ai-dialog-logo.98b3cc1a.png";